/** ReflectionProbe registration: the parser. Property knowledge for the linter lives in linterParser.ts. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseReflectionProbe } from './parser';
const reflectionProbeRegistration = {
    typeName: 'ReflectionProbe',
    parser: parseReflectionProbe,
};
nodeRegistry.register(reflectionProbeRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map